export default __webpack_public_path__ + "static/media/ico-sq-11-city.2dc9d805.svg";